import Post from 'flarum/common/models/Post';

export default function includePostNumber(post: Post | null, number: number) {
  if (!post) return false;
  if (Number(post.number()) === Number(number)) {
    return true;
  }
  const replies = post.mentionedBy();
  if (replies?.some((post) => includePostNumber(post, number))) {
    return true;
  }
  return false;
}
